export default {
    acc: 'https://acc.mrbilit.ir',
    auth: 'https://auth.mrbilit.ir',
    bill: 'https://bill.mrbilit.ir',
    bus: 'https://bus.mrbilit.ir',
    content: 'https://content.mrbilit.ir',
    coupon: 'https://coupon.mrbilit.ir',
    faas: 'https://fn.mrbilit.com',
    finalize: 'https://finalize.mrbilit.ir/api',
    flight: 'https://flight.mrbilit.com',
    giftCard: 'https://giftcard.mrbilit.ir/',
    hotel: 'https://hotel.mrbilit.ir',
    notifier: 'https://notifier.mrbilit.ir',
    panel: 'https://panel.mrbilit.com',
    payment: 'https://payment.mrbilit.com',
    priceTrack: 'https://pricetrack.mrbilit.ir',
    tracking: 'https://errortracking.mrbilit.net',
    train: 'https://train.mrbilit.com',
    flightInfo: 'https://flightinfo.mrbilit.ir',
    userLog: 'https://user-log.mrbilit.ir',
    workflow: 'https://workflow.mrbilit.ir',
    support: 'https://support.mrbilit.com',
    multiRoute: 'https://masir.mrbilit.com/',
};
